
        <mat-card>
            <mat-card-header>
                <mat-card-title>Seleccione ubicacion</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field appearance="fill" style="width: 49%;">
                    <mat-select [(ngModel)]="ubicacion">
                        <mat-option *ngFor="let u of ubicaciones" value="{{u}}">{{u}}</mat-option>
                    </mat-select>
                </mat-form-field>-
                <mat-form-field appearance="fill" style="width: 49%;">
                    <mat-select [(ngModel)]="ubicacion2">
                        <mat-option *ngFor="let u of ubicaciones2" value="{{u}}">{{u}}</mat-option>
                    </mat-select>
                </mat-form-field>

             
            </mat-card-content>
            <mat-card-footer class="actionButtons">
                <button mat-raised-button color="primary" [disabled]="ubicacion=='' || ubicacion2==''" class="button btnlarge" (click)="iniciarLector()"> Escanear bultos</button>
            </mat-card-footer>
            <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<mat-list>
    <mat-list-item *ngFor="let bulto of bultos; let i = index" class="element-item">
      <p class="element-value"><b>{{ bulto.codigo }}</b><br>{{ bulto.ubicacion }}</p>
      <div class="element-actions">
        <button mat-mini-fab color="warn" (click)="deleteElement(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-list-item>
  </mat-list>
        </mat-card>


  

  <div style="text-align: right;">
  <button [disabled]="bultos.length==0" mat-raised-button color="primary" (click)="guardarBultos()">Guardar bultos</button>
  </div>

<!--
<mat-card *ngFor="let bulto of  bultos" style="padding:2px;margin:2px">
    <mat-card-content><mat-icon>business_center</mat-icon>&nbsp;{{ bulto }}</mat-card-content>
</mat-card>-->
  